<script setup lang="ts">
import { TitleIndexProps } from "./TitleIndex.props"
import { sm as isMobile } from "~/utils/breakpoints"

defineProps<TitleIndexProps>()
</script>

<template>
  <Disclosure
    class="
      wrapper-generated-indexes
      bg-grey-main
      rounded
      px-4
      py-2
      md:px-6
      md:py-4
    "
    v-slot="{ open }"
    default-open
    as="div"
  >
    <DisclosureButton
      class="
        flex
        w-full
        items-center
        justify-between
        md:pointer-events-none
        md:select-none
      "
    >
      <h3 class="beaver-bold md:pig-bold md:py-2">
        {{ $t("wiki.categories.contentIndex") }}
      </h3>
      <UtilsIcon
        name="ChevronDown.svg"
        class="h-6 w-6 md:hidden"
        :class="open && 'rotate-180 transform'"
      />
    </DisclosureButton>
    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-out"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <DisclosurePanel
        class="beaver-medium-underlined"
        as="ul"
        :static="!isMobile"
      >
        <li
          v-for="heading in headings"
          :key="heading.id"
          class="py-2"
          :class="{ 'ml-2': heading.tagName === 'h3' }"
        >
          <a :href="`#${heading.id}`">
            {{ heading.text }}
          </a>
        </li>
      </DisclosurePanel>
    </transition>
  </Disclosure>
</template>
